import { render, staticRenderFns } from "./rewardAirshipEdit.vue?vue&type=template&id=ed0e892c&scoped=true&"
import script from "./rewardAirshipEdit.vue?vue&type=script&lang=js&"
export * from "./rewardAirshipEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0e892c",
  null
  
)

export default component.exports